import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { FaMapMarkerAlt } from "react-icons/fa";
import { Box, Button, CardActionArea, Stack } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { useNavigate } from 'react-router-dom';
import useResponsive from '../utils/Responsive';
import { MovingText } from '../utils/MovingText';
import { ImagePath, ImageRelativePath, Website_Url } from '../constants';
import { CustomTooltip } from '../utils/CustomTooltip';

const CourseCard = ({ item }) => {
    const navigate = useNavigate();
    const isSmallScreen = useResponsive("sm");

    const { title, location_name, is_featured, cover_image, slug, type, ratingDetails } = item;

    // ── Extract rating from ratingDetails ─────────────────────────────────────
    const totalRatings  = ratingDetails?.data?.overall?.total_ratings ?? 0;
    const averageRating = totalRatings > 0
        ? ratingDetails?.data?.overall?.average_rating
        : 5;

    const url = type === 6
        ? `${Website_Url}OnlineCourseDetail/${slug}`
        : `${Website_Url}CoursesDetail/${slug}`;

    const encodedMessage = encodeURIComponent(`Check out this awesome website! ${url}`);

    const handleWhatsAppShare = (e) => {
        e.stopPropagation();
        window.open(
            `https://wa.me/?text=${encodedMessage}`,
            '_blank',
            'noopener,noreferrer'
        );
    };

    return (
        <Card sx={{ boxShadow: "0px 4px 10px rgba(0,0,0,0.1)", bgcolor: "primary.light", borderRadius: "1.5rem", width: "100%", my: 1 }}>
            <CardActionArea
                onClick={() => type === 6
                    ? navigate(`/OnlineCourseDetail/${slug}`, { state: { courseName: title } })
                    : navigate(`/CoursesDetail/${slug}`, { state: { courseName: title } })
                }
                sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "start" }}
            >
                {/* ── Cover Image ─────────────────────────────────────────────── */}
                <CardContent
                    sx={{
                        backgroundImage: `url(${ImagePath}${ImageRelativePath}${cover_image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "250px",
                        width: "100%",
                        borderTopRightRadius: "1.5rem",
                        borderTopLeftRadius: "1.5rem",
                        py: { xs: 2, lg: 3 },
                        px: { xs: 2, lg: 5 },
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "start",
                    }}
                >
                    {is_featured === 1 && (
                        <Box
                            sx={{
                                clipPath: "polygon(29% 0, 57% 0, 56% 100%, 42% 84%, 28% 100%)",
                                backgroundColor: "red.main",
                                width: "120px",
                                height: "120px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: "absolute",
                                top: "0px",
                                right: "-20px",
                                pr: 3,
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{ transform: "rotate(-90deg)", color: "#fff", fontWeight: "bold" }}
                            >
                                Featured
                            </Typography>
                        </Box>
                    )}
                    <CustomTooltip icon='ic:round-share' onClick={handleWhatsAppShare} />
                </CardContent>

                {/* ── Card Body ───────────────────────────────────────────────── */}
                <CardContent sx={{ py: 3, px: 2, width: { xs: "100%", lg: "90%" } }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, width: "100%" }}>
                        {/* Title + Location */}
                        <Box width={"85%"}>
                            <MovingText text={title} />
                            <Typography variant="body2" color='grey.100' mt={0.5} sx={{ display: "flex", alignItems: "center" }}>
                                <FaMapMarkerAlt style={{ color: "#DC143C", fontSize: "16px", margin: "0 5px 0 0" }} />
                                {location_name}
                            </Typography>
                        </Box>

                        {/* ── Dynamic Rating Badge ─────────────────────────────── */}
                        <Box
                            sx={{
                                backgroundColor: "red.main",
                                display: "flex",
                                justifyContent: "center",
                                borderRadius: "12px",
                                px: 3,
                                py: 0.3,
                                gap: 0.5,
                                alignItems: 'center',
                                width: "13%",
                            }}
                        >
                            <Typography variant='body2' color='primary.main'>
                                {averageRating % 1 === 0 ? averageRating : averageRating.toFixed(1)}
                            </Typography>
                            <StarIcon sx={{ color: "primary.main", fontSize: "0.9rem" }} />
                        </Box>
                    </Box>

                    <Stack width="100%" justifyContent="center" alignItems="center">
                        <Button variant="outlined" component="div" sx={{ width: isSmallScreen ? "100%" : "80%" }}>
                            View Details
                        </Button>
                    </Stack>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default CourseCard;